import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class OtpSerializer extends BaseSerializer {
  deserialize(raw) {
    const serverRes = raw?.data || raw?.error;
    const success = serverRes?.statusCode == 200;
    if (!success) {
      return {
        statusCode: serverRes?.statusCode || raw?.status || 500,
        success: false,
        message:
          serverRes.message ||
          "Impossible d'envoyer le code de vérification. Veuillez réessayer.",
        // ancien message: (serverRes.message || "Erreur lors de d'envoie d'otp") + ` Code d'erreur: OTP_ERR_${serverRes.statusCode || raw.status || '1000'}`
        data: null
      };
    }
    return {
      statusCode: 200,
      success: true,
      message: 'Otp sent',
      data: {
        otp: serverRes.data?.otp,
        token: serverRes.data?.token,
        exp: serverRes.data?.exp
      }
    };
  }

  serialize(data) {
    if (!data) return null;

    let phoneNumber = data.phoneNumber;
    return {
      email: data.email,
      channel: data.channel,
      prefix: data.prefix,
      whatsappPhoneNumber: phoneNumber,
      phoneNumbers: phoneNumber,
      subject: 'Otp de vérification 1BPay',
      number: true,
      timestamp: new Date().toISOString(),
      service: '1bpay',
      name: data.name || 'Utilisateur',
      senderName: '1BPay',
      metadata: {
        eventToEmit: 'otpGenerated',
        eventTopic: 'lacasae-group-transaction',
        apiKey: 'email_live_51N8n9uHh7qjL2mXoGQpl7nqjLh2sKZt3mXoGQpl7',
        host: 'premium201.web-hosting.com',
        senderEmail: 'support@1bpay.me',
        password: 'cupm)Gf]cTz]',
      }
    };
  }
}

export const otpSerializer = new OtpSerializer();
